// extracted by mini-css-extract-plugin
export default {"container":"Social_container__zOWZ8","icon":"Social_icon__UTg4Y"};